import React, { useState, useEffect } from "react";
import HrmSidebar from "Components/Common/HrmSidebar";
import PagesWrapper from "Components/Common/Pages/PagesWrapper";
import AppWrapper from "Components/Routes/AppWrapper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import AllowanceApi from "api/hrmapi/allowance";
function UpdateAllowance() {
  const navigate = useNavigate();
  let params = useParams();
  const [updateAllowance, setUpdateAllowance] = useState({
    id: "",
    name: "",
    companyId: "",
  });
  const handleNavgetAll = () => {
    setTimeout(() => {
      navigate(`/all-allowances`);
    }, 2000);
  };
  const inputOnChange = (e) => {
    const { name, value } = e.target;
    setUpdateAllowance({
      ...updateAllowance,
      [name]: value,
    });
  };
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    AllowanceApi.viewAllowanceApi(params)
      .then((response) => {
        setUpdateAllowance({
          id: response.data.id,
          name: response.data.allowance_type,
          companyId: response.data.company_id,
        });
        setLoading(false);
      })
      .catch((error) => {
        const errorMessage = error.response?.data.message
          ? error.response.data.message
          : "An error occurred";

        toast.error(`Error: ${errorMessage}`);
        setLoading(false);
      });
  }, []);
  const handleAllowanceUpdate = (e) => {
    e.preventDefault();
    setLoading(true);
    AllowanceApi.updateAllowanceApi(params.id, {
      allowance: {
        allowance_type: updateAllowance.name,
        company_id: updateAllowance.companyId,
      },
    })
      .then((response) => {
        handleNavgetAll();
        const Message = response ? response.data.message : "An error occurred";
        toast.success(`${Message}`);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage = error.response?.data.message
          ? error.response.data.message
          : "An error occurred";

        toast.error(`Error: ${errorMessage}`);
      });
  };
  return (
    <AppWrapper sideBar={<HrmSidebar />}>
      <PagesWrapper>
        <div className="w-full flex mb-4 justify-between items-center pt-4">
          <div className="text-24">Allowance</div>
        </div>

        <div className="bg-white rounded-3xl w-full mt-5 min-h-[60vh]">
          <form onSubmit={handleAllowanceUpdate}>
            <div className="w-full flex gap-5 flex-wrap pl-4 pr-4">
              <div className="w-[32%]">
                <div className="flex w-full pt-5 pb-5">
                  <div>Name</div>
                  <div className="text-red">*</div>
                </div>
                <div>
                  <input
                    className="form-control"
                    name="name"
                    value={updateAllowance.name}
                    onChange={inputOnChange}
                    required
                  />
                </div>
              </div>
              <div className="flex w-full justify-end">
                <button
                  className={
                    loading
                      ? "w-[14%] btn-primary cursor-not-allowed"
                      : "w-[14%]  btn-primary"
                  }
                  type="submit"
                  disabled={loading}
                >
                  Update Allowance
                </button>
              </div>
            </div>
          </form>
        </div>
      </PagesWrapper>
    </AppWrapper>
  );
}

export default UpdateAllowance;
